import React, { Component } from 'react';
import {UIRouter, UIView, pushStateLocationPlugin,servicesPlugin} from 'ui-router-react'; 
import { CSSTransitionGroup } from 'react-transition-group'; 
import { ProgressBar } from 'react-fetch-progressbar';

import {getStatic} from './components/Factory'
import Head from './components/Head';
import Foot from './components/Foot';

import RootContainer from './containers/RootContainer';
import HomeContainer,{getHomedata,getKalenderData} from './containers/Homecontainer';

import ProgramContainer from './containers/ProgramContainer';
import AusstellungenContainer,{getExhibitionList} from './containers/AusstellungenContainer';
import AusstellungenDetailsContainer from './containers/AusstellungenDetailsContainer';
import KalenderContainer,{getPage,getkalenderItems,getKategories} from './containers/KalenderContainer';
import KalenderKategorieContainer from './containers/KalenderKategorieContainer';
import KalenderDetailsContainer,{getDetailsPage} from './containers/KalenderDetailsContainer';

import DiskussionenContainer,{getChildren} from './containers/DiskussionenContainer';
import DiskussionenDetailsContainer from './containers/DiskussionenDetailsContainer';

import InformationContainer from './containers/InformationContainer';
import PageContainer from './containers/PageContainer';
import NewsContainer,{getNewsData} from './containers/NewsContainer';
import NewsDetailsContainer from './containers/NewsDetailsContainer';
import TeamContainer,{getTeamPage,getTeamList} from './containers/TeamContainer';
import FreundContainer from './containers/FreundContainer';
import UnterstutzerContainer from './containers/UnterstutzerContainer';

import PresseContainer from './containers/PresseContainer';
import PresseReleaseContainer from './containers/PresseReleaseContainer';


import BesuchContainer from './containers/BesuchContainer';
import AboutContainer from './containers/AboutContainer';
import PublikationenContainer,{getPublikations} from './containers/PublikationenContainer';

import SearchContainer,{search} from './containers/SearchContainer';

import NotfoundContainer from './containers/NotfoundContainer';

import './css/bootstrap.min.css'; 
import './style.css'; 
import './transition.css'; 
import './react-popupbox.css'; 
 
class App extends Component {
 constructor() {
    super();
    this.state = { 
      menuData: [],
      staticData: [],
	  language:''
    }
	this.getMenuData = this.getMenuData.bind(this);
  }
  componentDidMount() {
	this.getMenuData('1');
  }
  getMenuData(type){
	let dataURL = getStatic();
    if(this.state.menuData.length)
		return this.state.menuData;
	else
		return fetch(dataURL)
		  .then(res => res.json())
		  .then(res => {
			this.setState({
			  menuData: res['menu'],
			  staticData:res['static']
			})  
			if(type!==1){
				return res['menu'];
			}		
		  })
	  
  }
  getStaticData(){
	let dataURL = getStatic();
	if(this.state.staticData.length)
		return this.state.staticData;
	else
		return fetch(dataURL)
		  .then(res => res.json())
		  .then(res => {
			this.setState({
			  menuData: res['menu'],
			  staticData:res['static']
			})  
			return res['static'];
		  })
  }
 render() {
	const languages = [ 'de','en' ];
	let rootState = {
						name:'root',
						url:'', 
						component:RootContainer,
					};
	const configRouter = router => {
		//router.urlRouter.otherwise({ state: 'root.404' })
		//router.locationConfig.baseHref("http://localhost:3000");
		//router.locationConfig.baseHref("http://taxispalais.staging.florianmatthias.com");
		router.locationConfig.baseHref("https://www.taxispalais.art");
	};
	let lang = document.location.pathname.split('/')[1];
	languages.map( (data,i)=>{
		if(data===lang){
			rootState = {
						name:'root',
						url:'/{lang}',   
						component:RootContainer,
					}
			//document.jsonPath = "http://taxispalais.staging.florianmatthias.com/"+lang+"/";
			document.jsonPath = "https://www.taxispalais.art/"+lang+"/";
			document.language = lang; 
		}
		else{
			document.menuLang = data;
			document.language = 'de';
		}
		return '';	
	});
	console.log(rootState)
	const states = [
					rootState,
					{
					  name: 'root.home',
					  url: '/', 
					  component: HomeContainer,
					  resolve: [
								{
									token: 'page',
									resolveFn: () => getPage('kalender')
								},								
								{
									token: 'kalenderData',
									resolveFn: () =>  getKalenderData()
								},
								{
									token: 'staticData',
									resolveFn: () =>  this.getStaticData()
								},
								{
									token: 'homeData',
									resolveFn: () => getHomedata()
								},
								{
									token: 'clearLang',
									resolveFn:()=>{ window.lang_switch = ''; }
								}
							]
					},
					{
					  name: 'root.programm',
					  url: '/programm',
					  component: ProgramContainer,
					  resolve: [
								{
									token: 'menuItems',
									resolveFn: () => this.getMenuData('0')
								}						
							]
					},
					{
						name: 'root.programm.ausstellungen',
						url: '/ausstellungen/',
						component: AusstellungenContainer,
						resolve: [
									{
										token:'page',
										resolveFn: () => getPage('ausstellungen','programm')
									},
									{
										token:'list',
										resolveFn: () => getExhibitionList()
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.programm.ausstellungendetails',
						url:'/ausstellungen/:item/',
						component:AusstellungenDetailsContainer,
						resolve: [ 
									{
										token: 'page',
										deps: ['$transition$'],
										resolveFn: (trans) => getDetailsPage(trans.params().item,'ausstellungen')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
						]
					}, 
					{
					  name: 'root.programm.kalender',
					  url: '/kalender/',
					  component: KalenderContainer,
					  resolve: [
								{
									token: 'page',
									resolveFn: () => getPage('kalender')
								},
								{
									token: 'kategory',
									resolveFn: () => { return ''; }
								},
								{
									token: 'kalenderItems',
									resolveFn: () => getkalenderItems('')
								},
								{
									token: 'staticData',
									resolveFn: () =>  this.getStaticData()
								},
								{
									token: 'kategories',
									resolveFn: () => getKategories('kalender-kategorie')
								},
								{
									token: 'clearLang',
									resolveFn:()=>{ window.lang_switch = ''; }
								}
							]
					},
					{
					  name: 'root.programm.kalender-kategorie',
					  url: '/kalender-kategorie/',
					  component: KalenderKategorieContainer,
					  resolve: [								
								{
									token: 'kategories',
									resolveFn: () => getKategories('kalender-kategorie')
								},
								{
									token: 'page',
									resolveFn: () => getPage('kalender')
								},
								{
									token: 'clearLang',
									resolveFn:()=>{ window.lang_switch = ''; }
								}
							]
					},
					{
					  name: 'root.programm.kalender-kategorie.name',
					  url: '/:item/',
					  component: KalenderContainer,
					  resolve: [								
								{
									token: 'kategory',
									deps: ['$transition$'],
									resolveFn: (trans) => { return trans.params().item; }
								},
								{
									token: 'staticData',
									resolveFn: () =>  this.getStaticData()
								},
								{
									token: 'kalenderItems',
									deps: ['$transition$'],
									resolveFn: (trans) => getkalenderItems(trans.params().item)
								}								
							]
					},
					{
						name: 'root.programm.kalenderdetails',
						url: '/kalender/:item/',
						component: KalenderDetailsContainer,
						resolve: [
									{
										token: 'page',
										deps: ['$transition$'],
										resolveFn: (trans) => getDetailsPage(trans.params().item,'kalender')
									},
									{
										token: 'kalenderPage',
										resolveFn: () => getPage('kalender')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
						]
					},
					{
					  name: 'root.diskussionen',
					  url: '/diskussionen/',
					  component: DiskussionenContainer,
					  resolve: [
								{
									token: 'menuItems',
									resolveFn: () => this.getMenuData('0')
								},
								{
									token: 'staticData',
									resolveFn: () =>  this.getStaticData()
								},
								{
									token: 'page',
									resolveFn: () => getPage('diskussionen')
								}, 
								{
									token: 'children',
									resolveFn: () => getChildren()
								},
								{
									token: 'clearLang',
									resolveFn:()=>{ window.lang_switch = ''; }
								}	
							]
					}, 
					{
						name: 'root.diskussionendetails',
						url: '/diskussionen/:item/',
						component: DiskussionenDetailsContainer,
						resolve: [								
								{
									token: 'page',
									deps: ['$transition$'],
									resolveFn: (trans) => getPage(trans.params().item)
								},
								{
									token: 'parent',
									resolveFn: () => getPage('diskussionen')
								}, 
								{
									token: 'menuItems',
									resolveFn: () => this.getMenuData('0')
								},	
							]
					},
					{
					  name: 'root.informationen',
					  url: '/informationen',
					  component: InformationContainer,
					  resolve: [
								{
									token: 'menuItems',
									resolveFn: () => this.getMenuData('0')
								}						
							]
					},
					{
					  name: 'root.informationen.neuigkeiten',
					  url: '/neuigkeiten/',
					  component: NewsContainer,
					  resolve: [
								  {
									token: 'newsPage',
									resolveFn: () => getPage('neuigkeiten')
								  },
								  {
									token: 'staticData',
									resolveFn: () =>  this.getStaticData()
								  },
								  {
									token: 'newsData',
									resolveFn: () => getNewsData()
								  },
								  {
									token: 'clearLang',
									resolveFn:()=>{ window.lang_switch = ''; }
								}
					  ]
					},
					{
						name:'root.informationen.newsdetails',
						url:'/neuigkeiten/:item/',
						component:NewsDetailsContainer,
						resolve: [ 
									{
										token: 'page',
										deps: ['$transition$'],
										resolveFn: (trans) => getDetailsPage(trans.params().item,'aktuelles')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
						]
					}, 
					{
						name:'root.informationen.team',
						url: '/team/',
						component: TeamContainer,
						resolve: [
									{
										token: 'teamPage',
										resolveFn: () => getTeamPage()
									},
									{
										token: 'teamList',
										resolveFn: () => getTeamList()
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.informationen.freund_innen',
						url: '/freund_innen/',
						component: FreundContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('freund_innen')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},					
					{
						name:'root.informationen.unterstuetzer',
						url: '/unterstuetzer/',
						component: UnterstutzerContainer,
						resolve: [
									{
										token: 'UnterstutzerPage',
										resolveFn: () => getPage('unterstuetzer')
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.informationen.das-taxispalais',
						url: '/das-taxispalais/',
						component: PageContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('das-taxispalais')
									},
									{
										token: 'name',
										resolveFn: () => { return 'information'; }
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.informationen.bibliothek',
						url: '/bibliothek/',
						component: PageContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('bibliothek')
									},
									{
										token: 'name',
										resolveFn: () => { return 'information'; }
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.presse',
						url: '/presse',
						component: PresseContainer,
						resolve: [
									{
										token: 'menuItems',
										resolveFn: () => this.getMenuData('0')
									},
						]
					},
					{
						name:'root.presse.presselogin',
						url:'/presselogin/',
						component:PresseReleaseContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('presselogin')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'login',
										resolveFn: () => { return 1 }
									},
									{
										token: 'pagetype',
										resolveFn: () => { return 'login' }
									}
						]
					},
					{
						name:'root.presse.ausstellungen',
						url:'/ausstellungen/',
						component:PresseReleaseContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('presselogin')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'login',
										resolveFn: () => { return 0 }
									},
									{
										token: 'pagetype',
										resolveFn: () => { return 'ausstellungen' }
									}									
						]
					},
					{
						name:'root.presse.neuigkeiten',
						url:'/neuigkeiten/',
						component:PresseReleaseContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('presselogin')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'login',
										resolveFn: () => { return 0 }
									},
									{
										token: 'pagetype',
										resolveFn: () => { return 'neuigkeiten' }
									}									
						]
					},
					{
						name:'root.presse.die-kunsthalle',
						url:'/die-kunsthalle/',
						component:PresseReleaseContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('presselogin')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'login',
										resolveFn: () => { return 0 }
									},
									{
										token: 'pagetype',
										resolveFn: () => { return 'die-kunsthalle' }
									}, 
									{
										token: 'slug',
										resolveFn: () => { return 'die-kunsthalle' }
									}									
						]
					},
					{
						name:'root.presse.ausstellungendetails',
						url:'/ausstellungen/:item/',
						component:PresseReleaseContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('presselogin')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'login',
										resolveFn: () => { return 0 }
									},
									{
										token: 'pagetype',
										resolveFn: () => { return 'ausstellungen.details' }
									},
									{
										token: 'slug',
										deps: ['$transition$'],
										resolveFn: (trans) => { return trans.params().item }
									},									
						]
					},					
					{
						name:'root.presse.neuigkeitendetails',
						url:'/neuigkeiten/:item/',
						component:PresseReleaseContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('presselogin')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'login',
										resolveFn: () => { return 0 }
									},
									{
										token: 'pagetype',
										resolveFn: () => { return 'neuigkeiten.details' }
									},
									{
										token: 'slug',
										deps: ['$transition$'],
										resolveFn: (trans) => { return trans.params().item }
									},									
						]
					},
					{
						name:'root.besuch',
						url: '/besuch',
						component: BesuchContainer,
						resolve: [
									{
										token: 'menuItems',
										resolveFn: () => this.getMenuData('0')
									}
						]
					},
					{
						name:'root.besuch.allgemeine-information',
						url: '/allgemeine-information/',
						component: AboutContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('allgemeine-information')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.besuch.publikationen',
						url: '/publikationen/',
						component: PublikationenContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('publikationen')
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
									{
										token: 'publikations',
										resolveFn: () => getPublikations()
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.besuch.cafe',
						url: '/cafe/',
						component: PageContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('cafe')
									},
									{
										token: 'name',
										resolveFn: () => { return 'besuch'; }
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.impressum',
						url: '/impressum/',
						component: PageContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('impressum')
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.datenschutzerklaerung',
						url: '/datenschutzerklaerung/',
						component: PageContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('datenschutzerklaerung')
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.nutzungsbedingungen',
						url: '/nutzungsbedingungen/',
						component: PageContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('nutzungsbedingungen')
									},
									{
										token: 'clearLang',
										resolveFn:()=>{ window.lang_switch = ''; }
									}
						]
					},
					{
						name:'root.search',
						url: '/search/:item/',
						component: SearchContainer,
						resolve: [
									{
										token: 'page',
										resolveFn: () => getPage('search')
									},
									{
										token: 'query',
										deps: ['$transition$'],
										resolveFn: (trans) => { return trans.params().item; }
									},
									{
										token: 'result',
										deps: ['$transition$'],
										resolveFn: (trans) => search(trans.params().item)
									},
									{
										token: 'staticData',
										resolveFn: () =>  this.getStaticData()
									},
						]
					},
					{
					  name: 'root.404',
					  url: '/{item:[a-zA-Z0-9-/]*}/',
					  component: NotfoundContainer,
					  resolve: [
								{
									token: 'menuItems',
									resolveFn: () => this.getMenuData('0')
								},
								{
									token: 'staticData',
									resolveFn: () =>  this.getStaticData()
								},	
								{
									token: 'clearLang',
									resolveFn:()=>{ window.lang_switch = ''; }
								}
							]
					},
				];
	const plugins = [
	  	  pushStateLocationPlugin,
		  servicesPlugin
	];
	
    return (		  
		  <UIRouter plugins={plugins} states={states} config={configRouter}>
			<div>
				<ProgressBar style={{ backgroundColor: 'black', height: '2px',position: 'fixed' }} />
				<UIView render={(Component, props) =>
				  <Head {...props} staticData={this.state.staticData} data={this.state.menuData}/>	
				} />							
				<UIView render={(Comp, props) =>
				  <CSSTransitionGroup 
					transitionName="example"
					transitionEnterTimeout={250}
					transitionLeaveTimeout={250}>
					<Comp {...props} key={props.transition} />
				  </CSSTransitionGroup>
				}/>
				{
					// eslint-disable-next-line 
					(this.state.staticData!='') ? 
					<Foot staticData={this.state.staticData} /> : ''
				}
			</div>
		  </UIRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js